var React = require('react');

function IcQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.088 5.73438H8.38L3.736 13.9044C1.586 17.6884 1.5 18.4624 1.5 20.0104C1.5 23.6224 4.51 26.4604 8.294 26.4604C11.992 26.4604 15.002 23.6224 15.002 20.0104C15.002 17.6024 13.712 15.6244 10.96 14.5064L15.088 5.73438ZM31.428 5.73438H24.72L20.076 13.9044C17.926 17.6884 17.84 18.4624 17.84 20.0104C17.84 23.6224 20.85 26.4604 24.634 26.4604C28.332 26.4604 31.342 23.6224 31.342 20.0104C31.342 17.6024 30.052 15.6244 27.3 14.5064L31.428 5.73438Z","fill":"currentColor"}));
}

IcQuote.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = IcQuote;

IcQuote.default = IcQuote;
